<template>
  <b-container fluid class="mx-auto">
    <b-navbar class="navigation px-5 pt-5">
      <b-navbar-brand to="/" class="brand d-flex align-items-center">
        <img class="img-fluid" src="@/assets/logo/flowscore-white.png" />
      </b-navbar-brand>
    </b-navbar>
  </b-container>
</template>
<script>
export default {
  name: "Navigation",
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
@import "../styles/components/navigation.scss";
</style>
